import { render } from "./ClosedFolder.vue?vue&type=template&id=1fe696a8&bindings={}"
import script from "./ClosedFolder.vue?vue&type=script&lang=js"
export * from "./ClosedFolder.vue?vue&type=script&lang=js"
script.render = render

export default script